import { ensureDefined } from '@avantia/client-and-server-utilities';
import { HpError } from '@avantia/logging-and-errors';
import { CheckBoxControl, HpImageButtonListControlProps } from '../../../engineClient/components/formControls/standard';
import { getQuestionStandardTextAndStyle } from '../../../engineClient/tools/utilities';
import { HpClientQuestionData, HpOnClickEvent } from '../../../engineClient/types';

export interface DeclarationCustomControlProps extends HpImageButtonListControlProps {
  onClick: HpOnClickEvent;
  optionText: string;
  questionText: string;
}

export interface DeclarationCopyText {
  declarationTerms: string[];
  heading: string;
  subHeading: string;
  headerDescription: string;
}

export function DeclarationCustomControl(props: DeclarationCustomControlProps): JSX.Element | null {
  const { question } = props;
  const { questionText } = getQuestionStandardTextAndStyle(question);
  const { data } = question;
  const { customData } = data as HpClientQuestionData;

  const DeclarationCopyText = ensureDefined(customData, 'customData') as unknown as DeclarationCopyText;
  const { declarationTerms, headerDescription } = DeclarationCopyText;
  if (!declarationTerms || !declarationTerms.length) {
    throw new HpError('The question must contain declaration terms.');
  }

  return (
    <div className="av-card declaration">
      <div className="av-text-semi-large">{headerDescription}</div>
      <ul className="av-text">
        {declarationTerms.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      <div className="av-card av-card-child">
        <div className="av-icon-grid">
          <div className="av-icon-grid-icon"></div>
          <div className="av-icon-grid-content">
            <strong>
              <CheckBoxControl
                {...props}
                data={data as HpClientQuestionData}
                optionText={questionText as string}
                questionText={''}
              />
            </strong>
          </div>
        </div>
      </div>
    </div>
  );
}
